import MenuIcon from '@mui/icons-material/Menu';
import MuiAppBar, { type AppBarProps as MuiAppBarProps } from '@mui/material/AppBar';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';

import * as React from 'react';
import { useEffect, useState } from "react";

import { signOut } from 'aws-amplify/auth';

import Log from '@/Logger';
import { type User } from '@/auth';
import { Drawer_Width } from "../constance";
import data from "./data.json";

type LicenseData = {
    name: string;
    publisher: string;
    licenseName: string;
    license: string;
    notice?: string;
};

type JsonData = {
    oss: LicenseData[];
};

interface AppBarProps extends MuiAppBarProps {
    open?: boolean;
}

const AppBar = styled(MuiAppBar, {
    shouldForwardProp: (prop) => prop !== 'open',
})<AppBarProps>(({ theme, open }) => ({
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
    }),
    ...(open && {
        marginLeft: Drawer_Width,
        width: `calc(100% - ${Drawer_Width}px)`,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    }),
}));

type Props = {
    user?: User;
    drawerOpen: boolean;
    handleDrawerOpen: () => void;
    iconButton: boolean;
}

const Header = (props: Props) => {
    const logger = Log.getLogger();

    const tenantId = props.user?.idToken.payload[import.meta.env.VITE_TENANT_ID_PROPERTY ?? '']

    const [licenses, setLicenses] = useState<LicenseData[]>([]);
    const wording = {
        headerTitle: 'RICOH eWhiteboard 4200',
        tenant: tenantId,
        signout: 'ログアウト',
        license: 'アプリ情報',
        licenseDialogTitle: 'OSSライセンス',
    }

    useEffect(() => {
        const jsonData = data as JsonData;
        setLicenses(jsonData.oss);
    }, []);

    const showOSS = () => {
        return (
            <div>
                {licenses.map((license) => (
                    <div key={license.name}>
                        <h2>{license.name}</h2>
                        <p>publisher : {license.publisher}</p>
                        <pre>{license.license}</pre>
                        <pre>{license.notice}</pre>
                    </div>
                ))}
            </div>
        )
    }

    const handleSignOut = () => {
        logger.ui.info("Header", "signOut");
        signOut();
    }

    const [open, setOpen] = React.useState(false);

    const handleClickOSSDialogOpen = () => {
        logger.ui.info("Header", "handleClickOSSDialogOpen");
        setOpen(true);
    };

    const handleOSSDialogClose = () => {
        logger.ui.info("Header", "handleOSSDialogClose");
        setOpen(false);
    };

    return (
        <>
            <AppBar position="fixed" open={props.drawerOpen}>
                <Toolbar>
                    {props.iconButton
                        ?
                        <IconButton
                            color="inherit"
                            aria-label="open drawer"
                            onClick={props.handleDrawerOpen}
                            edge="start"
                            sx={{
                                marginRight: 5,
                                ...(props.drawerOpen && { display: 'none' }),
                            }}
                        >
                            <MenuIcon />
                        </IconButton>
                        :
                        <div></div>
                    }

                    <Typography variant='h6' component='div' sx={{ flexGrow: 1 }} noWrap>
                        {wording.headerTitle}
                    </Typography>
                    {/* <span style={{ fontSize: 14, textAlign: 'center', paddingRight: 50, }}>テナントID : {wording.tenant}</span>  */}
                    <Button variant="text" onClick={handleClickOSSDialogOpen} color={'inherit'}>{wording.license}</Button>
                    <Button variant="text" onClick={handleSignOut} color={'inherit'}>{wording.signout}</Button>
                </Toolbar>
            </AppBar>
            <Dialog
                open={open}
                onClose={handleOSSDialogClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    {wording.licenseDialogTitle}
                </DialogTitle>
                <DialogContent>
                    <div>
                        {showOSS()}
                    </div>
                </DialogContent>
            </Dialog>
        </>
    );
};

export default Header;
